import { createSlice } from "@reduxjs/toolkit";
export const employerSlice = createSlice({
	name: "employer",
	initialState: {
		showPopup: false,
		editFormEducation: null,
		editFormContact: null,
		educationInfomation: [],
		contactInfomation: [],
	},
	reducers: {
		handleOpenPopup: (state) => ({
			...state,
			showPopup: true
		}),
		handleClosePopup: (state) => ({
			...state,
			showPopup: false
		}),
		editEducationInfo: (state, { payload: values }) => ({
			...state,
			editFormEducation: values,
		}),
		editContactInfo: (state, { payload: values }) => ({
			...state,
			editFormContact: values,
		}),
		setValueEducationInfo: (state, { payload: values }) => ({
			...state,
			educationInfomation: values,
		}),
		setValueContactInfo: (state, { payload: values }) => ({
			...state,
			contactInfomation: values,
		}),
		addEducationInfo: (state, { payload: values }) => {
			return {
				...state,
				educationInfomation: [...state.educationInfomation, values],
			};
		},
		addContactInfo: (state, { payload: values }) => {
			return {
				...state,
			};
		},
	},
});

export const {
	addEducationInfo,
	addContactInfo,
	editEducationInfo,
	editContactInfo,
	setValueEducationInfo,
	handleClosePopup,
	handleOpenPopup,
	setValueContactInfo,
} = employerSlice.actions;
export default employerSlice.reducer;
